module.exports = __webpack_public_path__ + "startpage-746fed5a/template-2-preview-be0bf8615fa2cdc59f7fbd14c0f4993c.jpg";